<template>
  <div
    v-show="getIsShowing"
    id="modal-view"
    class="modal-view-bg"
    :class="showBackground"

  >
    {{ $props.obj }}
    <ModalPrompt v-show="getModalType === 'prompt'" />
    <ModalCalendar v-show="getModalType === 'calendar'" />
    <SavedView v-show="getModalType === 'saved'" />
    <SnackBar v-show="getModalType === 'snack'" />
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { mapStores, storeToRefs } from 'pinia/dist/pinia';
import ModalCalendar from '@/components/modal/ModalCalendar';
import ModalPrompt from '@/components/modal/ModalPrompt';
import SavedView from '@/components/modal/SavedView';
import SnackBar from '@/components/modal/SnackBar';
export default {
  name: 'ModalView',
  components: {
    ModalCalendar,
    ModalPrompt,
    SavedView,
    SnackBar,
},
  setup () {
    const modalStore = useModalStore();
    const { getIsShowing, getModalType } = storeToRefs(modalStore);
    return {
      modalStore, getIsShowing, getModalType
    };
  },
  computed: {
    ...mapStores(useModalStore),
    showBackground () {
      return  (this.modalStore.background) ? 'modal-bg' : '';
    }
  },
  methods: {
    hideModal () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>
.modal-view-bg {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  pointer-events: none;
}

.modal-bg {
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;

}


</style>
